// import { getCommonParamsItemLabel } from '@/utils/common.js'

export const contentTableConfig = {
  title: '',
  propList: [
    {
      prop: 'code',
      label: 'profile.code'
    },
    {
      prop: 'name',
      label: 'general.name'
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      label: 'common.app-creation-time',
      width: 180
    },
    {
      label: 'common.app-operation',
      width: 280,
      slotName: 'handler'
    }
  ],
  showIndexColumn: true
}
